const Help = {
  init() {
    this.button = document.getElementById('help-button');
    this.container = document.getElementById('context-help');
    if (this.container) {
      this.button.style.display = 'inline-block';
    }
  }
};
document.addEventListener('turbo:load', Help.init.bind(Help));